export default "assets/images/acc6eab0ba9c470ae20fb4b74135e865.png";